import preventativeMaintenanceComponent from "./preventative_maintenance.component";

let preventativeMaintenanceModule = angular
  .module("preventativeMaintenance", [])

  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";

    $urlRouterProvider.otherwise("/preventativeMaintenance");

    $stateProvider.state("preventativeMaintenance", {
      url: "/v2/index.html#/preventative-maintenance",
      component: "preventativeMaintenance"
    });
  })
  .component("preventativeMaintenance", preventativeMaintenanceComponent).name;

export default preventativeMaintenanceModule;



// WEBPACK FOOTER //
// ./client/app/components/preventative_maintenance/index.js